import { render, staticRenderFns } from "./DocumentDisplayTab.vue?vue&type=template&id=1e3260e8&scoped=true&"
import script from "./DocumentDisplayTab.vue?vue&type=script&lang=js&"
export * from "./DocumentDisplayTab.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDisplayTab.vue?vue&type=style&index=0&id=1e3260e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3260e8",
  null
  
)

export default component.exports